import { createStore, applyMiddleware, compose } from "redux";
import {
  createStateSyncMiddleware,
  initMessageListener,
  initStateWithPrevTab,
} from "redux-state-sync";
import ReduxThunk from "redux-thunk";
import reducer from "./reducers";
const config = {
  // TOGGLE_TODO will not be triggered in other tabs
  channel: "video_data",
  blacklist: ["TOGGLE_TODO"],
};

const middlewares = [ReduxThunk, createStateSyncMiddleware(config)];

const store = createStore(
  reducer,
  {}, // default state of the application
  compose(applyMiddleware(...middlewares))
);
initStateWithPrevTab(store);
// initMessageListener(store);

export default store;
